export default __webpack_public_path__ + "media/images/icons/arrow-grey-b6081fd7488885f6539835d8b3c71c70.svg";